import Lottie from "lottie-react";
import styles from "./CasinoLoading.module.scss";
import CasinoLoader from "@/assets/lottie/Casino_Loader.json";
const CasinoLoading = ({ className = "" }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.loading}>
        <div className={styles.lottie}>
          <Lottie animationData={CasinoLoader} />
        </div>
      </div>
    </div>
  );
};

export default CasinoLoading;
